(function () {
  var burger = document.querySelector("[data-os-burger]");
  var nav = document.querySelector("[data-os-nav]");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      nav.classList.toggle("is-open");
    });
  }

  document.querySelectorAll("[data-os-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector("[data-os-main]");
    gallery.querySelectorAll("[data-os-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        gallery.querySelectorAll("[data-os-thumb]").forEach(function (b) { b.classList.remove("is-on"); });
        btn.classList.add("is-on");
        if (main) main.src = btn.getAttribute("data-src");
      });
    });
    var track = gallery.querySelector("[data-os-pdp-track]");
    if (!track) return;
    var prev = gallery.querySelector("[data-os-pdp-prev]");
    var next = gallery.querySelector("[data-os-pdp-next]");
    var thumbs = gallery.querySelectorAll("[data-os-pdp-thumb]");
    function step() {
      var slide = track.querySelector(".os-pdp__slide");
      return slide ? slide.getBoundingClientRect().width + 8 : track.clientWidth;
    }
    function currentIndex() {
      return Math.round(track.scrollLeft / step());
    }
    function setThumb(i) {
      thumbs.forEach(function (b, idx) { b.classList.toggle("is-on", idx === i); });
      var box = gallery.querySelector("[data-os-pdp-thumbs]");
      if (box && thumbs[i]) {
        var extra = thumbs[i].offsetLeft - (box.clientWidth - thumbs[i].offsetWidth) / 2;
        box.scrollTo({ left: Math.max(0, extra) });
      }
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      setThumb(currentIndex());
    }
    thumbs.forEach(function (btn) {
      btn.addEventListener("click", function () {
        track.scrollTo({ left: step() * Number(btn.getAttribute("data-os-pdp-thumb") || 0), behavior: "smooth" });
      });
    });
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update);
    update();
  });

  document.querySelectorAll("[data-os-steps]").forEach(function (sec) {
    var track = sec.querySelector("[data-os-steps-track]");
    var prev = sec.querySelector("[data-os-prev]");
    var next = sec.querySelector("[data-os-next]");
    var drag = sec.querySelector("[data-os-drag]");
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (drag && track.scrollWidth > 0) {
        var w = (track.clientWidth / track.scrollWidth) * 100;
        drag.style.width = w + "%";
        drag.style.left = (max > 0 ? (track.scrollLeft / max) * (100 - w) : 0) + "%";
      }
    }
    function step() {
      var card = track.querySelector(".os-step");
      return card ? card.getBoundingClientRect().width + 8 : 474;
    }
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update);
    update();
  });

  document.querySelectorAll("[data-os-clinical]").forEach(function (sec) {
    var after = sec.querySelector("[data-os-clinical-after]");
    if (!after) return;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function update() {
      if (reduced) {
        after.style.clipPath = "inset(0 0 0 0%)";
        return;
      }
      var rect = sec.getBoundingClientRect();
      var vh = window.innerHeight;
      var start = vh * 0.72;
      var end = vh * 0.22;
      var g = Math.max(0, Math.min(1, (start - rect.top) / Math.max(1, start - end)));
      after.style.clipPath = "inset(0 0 0 " + ((1 - g) * 100) + "%)";
    }
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });

  document.querySelectorAll("[data-os-films]").forEach(function (sec) {
    var track = sec.querySelector("[data-os-films-track]");
    var prev = sec.querySelector("[data-os-films-prev]");
    var next = sec.querySelector("[data-os-films-next]");
    if (!track) return;
    function step() {
      var card = track.querySelector(".os-pdp__film");
      return card ? card.getBoundingClientRect().width + 8 : 240;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
    track.addEventListener("scroll", update);
    update();
  });

  document.querySelectorAll("[data-os-buy]").forEach(function (form) {
    var qtyInput = form.querySelector("[data-os-qty]");
    var label = form.querySelector("[data-os-qty-label]");
    var sum = form.querySelector("[data-os-sum]");
    var unit = Number((sum && sum.textContent || "0").replace(/[^0-9.]/g, "")) || 0;
    function money(n) {
      return "$" + Number(n).toFixed(2);
    }
    function render(n, total) {
      qtyInput.value = String(n);
      if (label) label.textContent = String(n);
      if (sum) sum.textContent = money(total != null ? total : unit * n);
    }
    form.querySelectorAll("[data-os-qty-btn]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var next = Math.max(1, Number(qtyInput.value || 1) + Number(btn.getAttribute("data-os-qty-btn")));
        render(next);
      });
    });
    form.querySelectorAll("[data-os-pack]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        form.querySelectorAll("[data-os-pack]").forEach(function (b) { b.classList.remove("is-on"); });
        btn.classList.add("is-on");
        render(Number(btn.getAttribute("data-os-pack") || 1), btn.getAttribute("data-os-total"));
      });
    });
  });

  document.querySelectorAll("[data-os-cart]").forEach(function (form) {
    form.querySelectorAll("[data-os-cart-delta]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var box = btn.closest(".os-cart-qty");
        var input = box && box.querySelector("[data-os-cart-input]");
        if (!input) return;
        input.value = String(Math.max(0, Number(input.value || 0) + Number(btn.getAttribute("data-os-cart-delta"))));
        form.submit();
      });
    });
  });
})();
